import { NgIf, NgClass } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { QuillEditorComponent } from 'ngx-quill';
import { Item } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { CreateFolder, Asset } from 'app/models/document';
import { DocumentService } from 'app/services/document.service';
import { Util } from 'app/models/util';
import { EventService } from 'app/services/event.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector     : 'modal-rename-item',
    templateUrl  : './rename-item.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [
        MatButtonModule, 
        MatIconModule, 
        FormsModule, 
        ReactiveFormsModule, 
        MatFormFieldModule, 
        MatInputModule, 
        NgIf, 
        NgClass,
        QuillEditorComponent,
        MatProgressSpinnerModule],
})
export class RenameItemComponent implements OnInit
{
    renameItemForm: UntypedFormGroup;
    folder : CreateFolder = new CreateFolder();
    
    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<RenameItemComponent>,
        private _formBuilder: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: CreateFolder,
        public docService : DocumentService,
        public util : Util,
        public eventSer : EventService,
        public toastr : ToastrService

    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.folder = this.data ;
        console.log(this.folder)
        // Create the form
        this.renameItemForm = this._formBuilder.group({
            //Set default value of input field to the name of the item
            itemName: [this.data ? this.data.name : 'Untitled', Validators.required],
            description: [this.data ? this.data?.description : 'Untitled'],
        });

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Save and close
     */
    saveAndClose(): void
    {
        if(this.renameItemForm.invalid) return;
        // Create folder
        this.renameItem();

        // Close the dialog
        this.matDialogRef.close();
    }

    /**
     * Discard the action
     */
    cancel(): void
    {
        // Close the dialog
        this.matDialogRef.close();
    }
    /**
     * Rename item
     */
    renameItem(): void {
        console.log(this.data)
        this.docService.saveFolder(this.data).then((res)=>{
            this.data = this.docService.getData(res);
            this.renameItemForm.enable();
            // this.fileList.getDocument();
            this.toastr.info("Item has been renamed");
            this.matDialogRef.close();
            this.eventSer.getData.emit(true)
            this.eventSer.getGlobalData.emit('recent');
        }).catch((error)=>{
            console.log(error);
        })
    }

    /**
     * Set item name
     * 
     */
    setPlaceholder(): string { 
        return this.data ? this.data.name : 'Untitled';
    }

    /**
     * Retrieves the editor toolbar options.
     * 
     * @returns The editor toolbar options.
     */
    getEditorToolbar(){
        return Util.getEditorToolbarOptions();
    }
}
